/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CopyrightedImageProtocolsBulkUpdateCopyrightedImagesRequest,
  CopyrightedImageProtocolsCreateCollectionRequest,
  CopyrightedImageProtocolsCreateCollectionResponse,
  CopyrightedImageProtocolsCreateCopyrightedImagesPresignedRequest,
  CopyrightedImageProtocolsDeleteCollectionRequest,
  CopyrightedImageProtocolsDeleteCopyrightedImagesRequest,
  CopyrightedImageProtocolsGetAllCopyrightedImagesRequest,
  CopyrightedImageProtocolsGetAllCopyrightedImagesResponse,
  CopyrightedImageProtocolsGetCollectionDetailsRequest,
  CopyrightedImageProtocolsGetCollectionDetailsResponse,
  CopyrightedImageProtocolsGetCollectionFilterRequest,
  CopyrightedImageProtocolsGetCollectionsRequest,
  CopyrightedImageProtocolsGetCollectionsResponse,
  CopyrightedImageProtocolsGetCopyrightedImageDetailRequest,
  CopyrightedImageProtocolsGetCopyrightedImageDetailResponse,
  CopyrightedImageProtocolsGetCopyrightedImagePresignedUrlRequest,
  CopyrightedImageProtocolsGetCopyrightedImagePresignedUrlResponse,
  CopyrightedImageProtocolsUpdateCollectionRequest,
  CopyrightedImageProtocolsUpdateCopyrightedImageRequest,
  MarqCommonProtocolEmptyResponse,
  MonitoringFilterProtocolResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class CopyrightedImage<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags CopyrightedImage
   * @name GetAllCopyrightedImagesCreate
   * @request POST:/copyrighted-image/get-all-copyrighted-images
   */
  getAllCopyrightedImagesCreate = (
    data: CopyrightedImageProtocolsGetAllCopyrightedImagesRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<CopyrightedImageProtocolsGetAllCopyrightedImagesResponse, any>({
      path: `/copyrighted-image/get-all-copyrighted-images`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CopyrightedImage
   * @name GetCopyrightedImageDetailCreate
   * @request POST:/copyrighted-image/get-copyrighted-image-detail
   */
  getCopyrightedImageDetailCreate = (
    data: CopyrightedImageProtocolsGetCopyrightedImageDetailRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<CopyrightedImageProtocolsGetCopyrightedImageDetailResponse, any>({
      path: `/copyrighted-image/get-copyrighted-image-detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CopyrightedImage
   * @name GetCollectionFilterCreate
   * @request POST:/copyrighted-image/get-collection-filter
   */
  getCollectionFilterCreate = (data: CopyrightedImageProtocolsGetCollectionFilterRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/copyrighted-image/get-collection-filter`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CopyrightedImage
   * @name GetCollectionsCreate
   * @request POST:/copyrighted-image/get-collections
   */
  getCollectionsCreate = (data: CopyrightedImageProtocolsGetCollectionsRequest, params: RequestParams = {}) =>
    this.http.request<CopyrightedImageProtocolsGetCollectionsResponse, any>({
      path: `/copyrighted-image/get-collections`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CopyrightedImage
   * @name GetCopyrightedImagePresignedUrlCreate
   * @request POST:/copyrighted-image/get-copyrighted-image-presigned-url
   */
  getCopyrightedImagePresignedUrlCreate = (
    data: CopyrightedImageProtocolsGetCopyrightedImagePresignedUrlRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<CopyrightedImageProtocolsGetCopyrightedImagePresignedUrlResponse, any>({
      path: `/copyrighted-image/get-copyrighted-image-presigned-url`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CopyrightedImage
   * @name AddPresignedCopyrightedImagesCreate
   * @request POST:/copyrighted-image/add-presigned-copyrighted-images
   */
  addPresignedCopyrightedImagesCreate = (
    data: CopyrightedImageProtocolsCreateCopyrightedImagesPresignedRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/copyrighted-image/add-presigned-copyrighted-images`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CopyrightedImage
   * @name UpdateCopyrightedImageCreate
   * @request POST:/copyrighted-image/update-copyrighted-image
   */
  updateCopyrightedImageCreate = (
    data: CopyrightedImageProtocolsUpdateCopyrightedImageRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/copyrighted-image/update-copyrighted-image`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CopyrightedImage
   * @name DeleteCopyrightedImagesCreate
   * @request POST:/copyrighted-image/delete-copyrighted-images
   */
  deleteCopyrightedImagesCreate = (
    data: CopyrightedImageProtocolsDeleteCopyrightedImagesRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/copyrighted-image/delete-copyrighted-images`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CopyrightedImage
   * @name BulkUpdateCopyrightedImagesCreate
   * @request POST:/copyrighted-image/bulk-update-copyrighted-images
   */
  bulkUpdateCopyrightedImagesCreate = (
    data: CopyrightedImageProtocolsBulkUpdateCopyrightedImagesRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/copyrighted-image/bulk-update-copyrighted-images`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CopyrightedImage
   * @name GetCollectionDetailsCreate
   * @request POST:/copyrighted-image/get-collection-details
   */
  getCollectionDetailsCreate = (
    data: CopyrightedImageProtocolsGetCollectionDetailsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<CopyrightedImageProtocolsGetCollectionDetailsResponse, any>({
      path: `/copyrighted-image/get-collection-details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CopyrightedImage
   * @name CreateCollectionCreate
   * @request POST:/copyrighted-image/create-collection
   */
  createCollectionCreate = (data: CopyrightedImageProtocolsCreateCollectionRequest, params: RequestParams = {}) =>
    this.http.request<CopyrightedImageProtocolsCreateCollectionResponse, any>({
      path: `/copyrighted-image/create-collection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CopyrightedImage
   * @name UpdateCollectionCreate
   * @request POST:/copyrighted-image/update-collection
   */
  updateCollectionCreate = (data: CopyrightedImageProtocolsUpdateCollectionRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/copyrighted-image/update-collection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CopyrightedImage
   * @name DeleteCollectionCreate
   * @request POST:/copyrighted-image/delete-collection
   */
  deleteCollectionCreate = (data: CopyrightedImageProtocolsDeleteCollectionRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/copyrighted-image/delete-collection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
